(function () {
  'use strict';

  var grids = [];

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function matches(item, product) {
    var handle = normalize(item.dataset.ecofootProductHandle);
    var sku = normalize(item.dataset.ecofootProductSku);
    return (handle && handle === normalize(product.handle)) ||
      (sku && sku === normalize(product.sku));
  }

  function findItem(grid, product) {
    return Array.prototype.find.call(
      grid.querySelectorAll('[data-ecofoot-product-item]'),
      function (item) { return matches(item, product); }
    );
  }

  function sectionUrl(grid, page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', grid.dataset.sectionId);
    url.hash = '';
    return url.toString();
  }

  function acquireItem(grid, product) {
    var existing = findItem(grid, product);
    if (existing) return Promise.resolve(existing);
    var pages = Number(grid.dataset.totalPages || 1);
    var page = 2;

    function next() {
      if (page > pages) return Promise.resolve(null);
      return fetch(sectionUrl(grid, page), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load the complete product catalogue.');
          return response.text();
        })
        .then(function (html) {
          var documentPage = new DOMParser().parseFromString(html, 'text/html');
          var found = findItem(documentPage, product);
          page += 1;
          return found ? found.cloneNode(true) : next();
        });
    }
    return next();
  }

  function removeBadges(item) {
    item.classList.remove('ecofoot-ai-grid__recommended', 'ecofoot-ai-grid__alternative');
    item.querySelectorAll('[data-ecofoot-ai-badge]').forEach(function (badge) { badge.remove(); });
  }

  function badge(item, label, type) {
    removeBadges(item);
    item.classList.add('ecofoot-ai-grid__' + type);
    var marker = document.createElement('span');
    marker.className = 'ecofoot-ai-grid__badge';
    marker.dataset.ecofootAiBadge = 'true';
    marker.textContent = label;
    item.prepend(marker);
  }

  function clearGrid(grid) {
    var list = grid.querySelector('#product-grid');
    if (!list) return;
    grid.querySelectorAll('[data-ecofoot-ai-clone]').forEach(function (item) { item.remove(); });
    (grid._ecofootOriginalItems || []).forEach(function (item) {
      item.hidden = false;
      item.style.display = '';
      removeBadges(item);
      list.appendChild(item);
    });
    var banner = grid.querySelector('[data-ecofoot-ai-grid-banner]');
    if (banner) banner.remove();
    grid.classList.remove('ecofoot-ai-grid--filtered', 'ecofoot-ai-grid--resolving');
  }

  function renderBanner(grid, hasAlternative) {
    var old = grid.querySelector('[data-ecofoot-ai-grid-banner]');
    if (old) old.remove();
    var banner = document.createElement('div');
    banner.className = 'ecofoot-ai-grid__banner';
    banner.dataset.ecofootAiGridBanner = 'true';
    var copy = document.createElement('div');
    copy.className = 'ecofoot-ai-grid__banner-copy';
    var heading = document.createElement('strong');
    heading.className = 'ecofoot-ai-grid__banner-heading';
    heading.textContent = 'EcoFoot AI recommended the following products.';
    var detail = document.createElement('p');
    detail.textContent =
      'Based on the verified equipment footprint and operating weight.';
    copy.appendChild(heading);
    copy.appendChild(detail);
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.textContent = 'Clear AI Recommendation';
    clear.addEventListener('click', function () {
      clearGrid(grid);
      try { sessionStorage.removeItem('ecofoot-ai-recommendation'); } catch (_error) {}
      var url = new URL(window.location.href);
      url.searchParams.delete('ecofoot_ai');
      url.searchParams.delete('recommendation');
      if (url.hash === '#ecofoot-product-grid') url.hash = '';
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    });
    banner.appendChild(copy);
    banner.appendChild(clear);
    var list = grid.querySelector('#product-grid');
    list.parentNode.insertBefore(banner, list);
  }

  function applyToGrid(grid, recommendation) {
    if (!recommendation || !recommendation.recommended) return Promise.resolve();
    var list = grid.querySelector('#product-grid');
    if (!list) return Promise.resolve();
    clearGrid(grid);
    grid.classList.add('ecofoot-ai-grid--resolving');
    var products = [recommendation.recommended];
    var grouped = Boolean(
      recommendation.productPageValidation &&
      recommendation.productPageValidation.groupedConfiguration &&
      recommendation.requiredLineItems &&
      recommendation.requiredLineItems.length
    );
    if (grouped) {
      recommendation.requiredLineItems.forEach(function (lineItem) {
        var exists = products.some(function (product) {
          return matchesIdentity(product, lineItem);
        });
        if (!exists) products.push({ handle: lineItem.handle, sku: lineItem.sku });
      });
    }
    var requiredProductCount = products.length;
    if (
      recommendation.alternative &&
      !products.some(function (product) {
        return matchesIdentity(product, recommendation.alternative);
      })
    ) products.push(recommendation.alternative);
    return Promise.all(products.map(function (product) {
      return acquireItem(grid, product);
    })).then(function (items) {
      var recommended = items[0];
      var alternativeIndex = recommendation.alternative
        ? products.findIndex(function (product) {
            return matchesIdentity(product, recommendation.alternative);
          })
        : -1;
      var alternative = alternativeIndex > 0 ? items[alternativeIndex] : null;
      if (!recommended) throw new Error('The recommended frame is not present in this collection.');
      if (items.slice(0, requiredProductCount).some(function (item) { return !item; })) {
        throw new Error('A required recommended product is not present in this collection.');
      }
      var visibleItems = items.filter(function (item) { return Boolean(item); });
      visibleItems.forEach(function (item) {
        if (!item.isConnected) {
          item.dataset.ecofootAiClone = 'true';
          list.appendChild(item);
        }
      });
      Array.prototype.forEach.call(list.querySelectorAll('[data-ecofoot-product-item]'), function (item) {
        item.hidden = visibleItems.indexOf(item) === -1;
        item.style.display = visibleItems.indexOf(item) === -1 ? 'none' : '';
      });
      visibleItems.slice().reverse().forEach(function (item) { list.prepend(item); });
      badge(recommended, 'EcoFoot AI Recommended', 'recommended');
      if (alternative) {
        recommended.insertAdjacentElement('afterend', alternative);
        badge(
          alternative,
          recommendation.alternativeRole === 'individual_unit_option'
            ? 'Get Individually'
            : 'Higher-capacity alternative',
          'alternative'
        );
      }
      grid.classList.add('ecofoot-ai-grid--filtered');
      grid.classList.remove('ecofoot-ai-grid--resolving');
      renderBanner(grid, visibleItems.length > 1);
      scrollToGrid(grid);
    });
  }

  function matchesIdentity(left, right) {
    return Boolean(
      normalize(left && left.handle) &&
      normalize(left.handle) === normalize(right && right.handle)
    ) || Boolean(
      normalize(left && left.sku) &&
      normalize(left.sku) === normalize(right && right.sku)
    );
  }

  function scrollToGrid(grid) {
    var sticky = document.querySelector(
      'sticky-header, [data-sticky-header], .header-wrapper'
    );
    var offset = sticky ? sticky.getBoundingClientRect().height : 0;
    var anchor = document.getElementById('ecofoot-product-grid') || grid;
    var top = anchor.getBoundingClientRect().top + window.scrollY - offset - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function init(grid) {
    if (grid.dataset.ecofootAiGridBound === 'true') return;
    grid.dataset.ecofootAiGridBound = 'true';
    grid._ecofootOriginalItems = Array.prototype.slice.call(
      grid.querySelectorAll('#product-grid > [data-ecofoot-product-item]')
    );
    var params = new URLSearchParams(window.location.search);
    if (params.get('ecofoot_ai') === '1' && params.get('recommendation')) {
      grid.classList.add('ecofoot-ai-grid--resolving');
    }
    grids.push(grid);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ecofoot-ai-grid]').forEach(init);
  }

  function apply(recommendation) {
    return Promise.all(grids.filter(function (grid) { return grid.isConnected; }).map(function (grid) {
      return applyToGrid(grid, recommendation).catch(function (error) {
        clearGrid(grid);
        window.dispatchEvent(new CustomEvent('ecofoot:recommendation-grid-error', {
          detail: { message: error.message }
        }));
        throw error;
      });
    }));
  }

  function clear() {
    grids.filter(function (grid) { return grid.isConnected; }).forEach(clearGrid);
  }

  window.EcoFootRecommendationGrid = { apply: apply, clear: clear };
  window.addEventListener('ecofoot:recommendation-resolved', function (event) { apply(event.detail); });
  window.addEventListener('ecofoot:recommendation-clear', clear);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
